import { useQuery } from '@tanstack/react-query';

import { WorkingHours } from 'src/features/workingHours/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/site/:siteId/site-working-hours/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    siteId: string;
    parkingId: string;
}

const queryFn = (
    { siteId, parkingId, ...params }: DTO,
    signal: AbortSignal,
): Promise<ListResponseSmartParkAPI<WorkingHours>> => {
    return axios.get(formatResourcePath(RESOURCE, { siteId, parkingId }), { params, signal });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async ({ signal }) => await queryFn(payload, signal),
        staleTime: 1000 * 60 * 30,
        ...config,
    });
};

export { RESOURCE as LIST_WORKING_HOURS_RESOURCE, useQueryHook as useListWorkingHours };
